import {
    gsap
} from "gsap/dist/gsap";
import {
    ScrollTrigger
} from "gsap/dist/ScrollTrigger";
import {
    ScrollToPlugin
} from "gsap/dist/ScrollToPlugin";

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);
let mainContent = document.getElementById('site');
var preLoaderEl = document.querySelector('.preloader');
const headerBar = mainContent.querySelector('#masthead');
var headerBarAnimate = gsap.timeline({
    paused: true, // default is false
    smoothChildTiming: true,
});
headerBarAnimate
    .fromTo(
        headerBar, {
            opacity: 0,
        }, {
            opacity: 1,
        },
    )
    .fromTo(headerBar, {
        scale: 0.95
    }, {
        scale: 1,
        ease: "power3.in",
        duration: 1
    });

let tl = gsap.timeline({
    paused: true, // default is false
    defaults: { // children inherit these defaults
        duration: 1,
        ease: "power2.out",

    },
    smoothChildTiming: true,
});

tl
    .fromTo('#riko', {
        y: '50px',
        duration: .8
    }, {
        y: '0%',
    }, '<.2')
    .to("#riko .card-profile-container", {
        scale: 1,
    }, "<.2")
    .fromTo("#riko .card-profile-container img.enable-anima", {
        scale: 1,
        rotation: -5,
        duration: 0.7,
      
    }, {
        scale: 0.9,
        rotation: 0,
       
    }, "<.2")
    .to("#riko .card-profile-container .card-profile", {
        duration: 1,
        opacity: 1,
    }, "<.1")
    .to("#riko .card-profile-container .card-profile .card-title", {
        duration: 1,
        opacity: 1,
        scale: 1,
    }, "<.2")
    .fromTo("#riko .card-profile-container .card-profile .about-profile", {
        opacity: 0,
        y: "20%",
        duration: .5,
        scale: 1,
    }, {
        opacity: 1,
        scale: 1,
        y: "0%"
    }, "<.2")

    .to("#riko .card-profile-container .card-profile .item-sosmed", {
        duration: .8,
        opacity: 1,
        y: 0,
        x: 0,
        stagger: 0.1
    }, "<.1");
    const itemSosmed = document.querySelectorAll("#riko .item-sosmed")
    tl.eventCallback("onComplete", function () {
        itemSosmed.forEach(function (item) {
            item.classList.add('duration-500');
        });
      });
document.addEventListener("DOMContentLoaded", function () {

    if (preLoaderEl) {
        setTimeout(function () {
            preLoaderEl.classList.add('hide');
            mainContent.classList.remove('overflow-hidden');
            mainContent.classList.remove('opacity-0');
            mainContent.classList.add('opacity-100');
            window.scroll({
                top: 0,
                left: 0,
                behavior: 'smooth'
            });
        }, 1300);
    }

    setTimeout(function () {
        headerBarAnimate.play();
        tl.play();
        let topOrnament = gsap.timeline({
            paused: true, // default is false
            defaults: { // children inherit these defaults
                duration: 1.5,
                ease: "power2.out"
            },
            smoothChildTiming: true,
        });
        topOrnament.fromTo('.top-page-ornament', {
            opacity: 0,
            scale: 0.6
        }, {
            opacity: 1,
            scale: 1,
        }, '<.1')
        .fromTo('.page-title h1',
        {
            opacity: 0,
            scale: 1.2
        },
        {
            opacity: 1,
            scale: 1,
            duration:.5
        }, '<.1')
        .fromTo('.custom-title-desc p',
        {
            opacity: 0,
            scale: 1.2
        },
        {
            opacity: 1,
            scale: 1,
            duration: .5,
            delay: .1
        }, '<.1')
        .play();
    }, 1300)
})

// function leftHandleScroll() {
//     leftImages.forEach(image => {
//         const rect = image.getBoundingClientRect();
//         const translateY = window.scrollY - rect.top;

//         gsap.to(image, {
//             x: translateY > 0 ? -translateY / 8 : 0, 
//             ease: 'none'
//         });
//     });
// }
// window.addEventListener('scroll', leftHandleScroll);
// function rightHandleScroll() {
//     rightImages.forEach(image => {
//         const rect = image.getBoundingClientRect();
//         const translateY = window.scrollY - rect.top;
    
//         gsap.to(image, {
//             x: translateY > 0 ? translateY / 8 : 0, 
//             ease: 'none'
//         });
//     });
// }
// window.addEventListener('scroll', rightHandleScroll);

var cardBudiarti = document.getElementById('budiarti');

var cardBudiartiAnimate = gsap.timeline({
    scrollTrigger: {
        trigger: '.item-sosmed',
        // markers: false,
        start: "center 60%",
        end: "bottom 30%",
    },
    paused: false, // default is false
    defaults: { // children inherit these defaults
        duration: 1,
        ease: "power2.out"
    },
    smoothChildTiming: true,
});

cardBudiartiAnimate
    .from(cardBudiarti.querySelector('.card-profile'), {
        scrollTrigger: '.card-profile',
        opacity: 0,
    })

    .from(cardBudiarti.querySelector('.card-profile .card-title'), {
        scale: 1.5,
        x: "17px",
        y: "10px",
        opacity: 0
    }, "<.2")
    .fromTo("#budiarti .card-profile-container .card-profile .about-profile", {
        opacity: 0,
        y: "20%",
        duration: .5,
        scale: 1,
    }, {
        opacity: 1,
        scale: 1,
        y: "0%"
    }, "<.1")
    .to("#budiarti .card-profile-container .card-profile .item-sosmed", {
        duration: .8,
        opacity: 1,
        y: 0,
        x: 0,
        stagger: 0.1
    }, "<.1");
    const itemSosmedBudi = document.querySelectorAll("#budiarti .item-sosmed")
    cardBudiartiAnimate.eventCallback("onComplete", function () {
        itemSosmedBudi.forEach(function (item) {
            item.classList.add('duration-500');
        });
      });
var orelyCore = document.getElementById('orelycore');

var orelyCoreAnimate = gsap.timeline({
    scrollTrigger: {
        trigger: "#orelycore",
        start: "top center",
        end: "bottom center",
        // toggleActions: "play none none reverse",
        // repeat: -1
    },
    paused: false, // default is false
    defaults: { // children inherit these defaults
        duration: 1.3,
        ease: "power2.out"
    },
    smoothChildTiming: true,

});
orelyCoreAnimate

    .fromTo("#orelycore .image-animations", {

        scale: 0.7,
        x: "-5%",
        duration: .8
    }, {
        scale: 1,
        x: "-5%"
    }, "<.1")
    .fromTo(orelyCore.querySelector(".left-content .content-desc"), {
        opacity: 0,
        y: "20%",
        scale: 1,
    }, {
        opacity: 1,
        scale: 1,
        y: "0%"
    }, "<.2")
    .fromTo("#orelycore .left-content .content-title", {
        scale: 1.2,
        opacity: 0,
        transformOrigin: "center center",
    }, {
        scale: 1,
        opacity: 1,
    }, "<.1")



var ourDigitalWarrior = document.getElementById('digital-warrior');

let animateDigital = gsap.timeline({
    scrollTrigger: {
        trigger: "#digital-warrior",
        start: "top center",
        end: "bottom center",
    },
    paused: false, // default is false
    defaults: { // children inherit these defaults
        duration: 1.3,
        ease: "power2.out"
    },
    smoothChildTiming: true,
})
animateDigital
    .fromTo('.section-title', {
        opacity: 0,
        duration: 0.8,
        scale: 1.2
    }, {
        opacity: 1,
        scale: 1,
        stagger:.1
    }, '<.2')
    .fromTo('.digital_warriors_list', {
        y: '30%',
        duration: 0.8
    }, {
        y: "0%",
    }, '<.1')